import kidsGames from './kids-games.json'

export type KidsGame = {
    hru: string
    title: string
    previewUrl: string
    gameUrl: string
    source: string
    ageRating: string
    videoId?: string
    videoUrl?: string
}

export const KIDS_GAMES: KidsGame[] = kidsGames
